import React from 'react'
import NewMenuItem from "./menu-item"
import VScroll from "../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import {ReportsSelectorGroup} from "../templates/get-templates";
import Search from "../../../../quick-add/layout/menu/search/search";

type Props = {
    menuItems     : any[]
    selectedGroup : ReportsSelectorGroup
    onSelectGroup : callback

    searchValue   : string
    setSearchValue: callback
}

export default function LeftMenu(props: Props){


    const clearSearchValue = () => {
        props.setSearchValue("")
    }

    return (
        <div className="new-menu">
            <div className="ui5-menu">

                <div className="menu-top">
                    <div className="ui5-title-app-name p-l-25">New Report</div>
                </div>

                <Search classes          = "m-t-20"
                        value            = {props.searchValue}
                        onChange         = {(value: string) => props.setSearchValue(value)}
                        clearSearchValue = {clearSearchValue}/>

                <VScroll className="menu-sections with-search m-t-20">
                    <div className="menu-section open">

                        {props.searchValue.length === 0  && _.map(props.menuItems, (group: ReportsSelectorGroup, key) =>{

                            const selected = props.selectedGroup.value === group.value;

                            return (
                                <NewMenuItem key        = {key}
                                             group      = {group}
                                             selected   = {selected}
                                             onClick    = {props.onSelectGroup}/>)

                        })}
                    </div>
                </VScroll>
            </div>
        </div>
    );
}
